/**
 * @packageDocumentation
 * @module @yimoka/web-http
 * @summary 基于 axios 的 Web HTTP 客户端（apiExecutor + IHTTPResponse 归一化 + gRPC 单 key 解包）
 * @author keep
 * @since 0.0.1
 */

export { createWebHttpClient } from './create-web-http-client';
export {
  createNetworkErrorResponse,
  getResponseData,
  handleAxiosError,
  handleAxiosResponse,
} from './handle-axios-response';
export type {
  IWebHttpClient,
  IWebHttpClientOptions,
  IWebHttpDefaultHeaders,
} from './types';
